import React from 'react'
import { Link } from 'react-router-dom'

export const NotFound = () => {
  return (
    <main className="container py-5 text-center">
      <h1>Page not found</h1>
      <p>The page or link you are looking for has been removed or changed.</p>
      <Link to="/">Go back to home</Link>
    </main>
  )
}

export default NotFound
